const actionTypeIdentifier = '4F7FF612-4701-4438-8DF9-47247AD6D34E'; // to generate open ssms run select newid()

//location form actions
export const setSubscriptionDetails = `SET-WIRELESS-PORTOUT-SUBSCRIPTION-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-PORTOUT-SUBSCRIPTION-FORM-SUBMITTED-${actionTypeIdentifier}`;

export const setFormLoading = `SET-WIRELESS-PORTOUT-SUBSCRIPTION-FORM-LOADING-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELESS-PORTOUT-SUBSCRIPTION-RESET-LOADING-${actionTypeIdentifier}`;

export const wirelessPortOutModel = {
    circuitCode: ''
    , circuitId: 0
    , businessJustification: ''
    , additionalInformation: ''
    , terminateDate: ''
}
